<nav class="navbar navbar-expand-lg navbarBoxShadow">
    <div class="container">
      <a class="navbar-brand" href="javascript:void(0);" (click)="goToHome()">
        <img
          src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/instaciti-logo.png"
          class="img-fluid logoWidth"
          alt="instacity-logo"
        />
      </a>
  
      <a
        class="nav-link font16 font600 btn btn-sm custom-btnShadow text-white orangeGradientButton mobileViewDisaplay align-self-center"
        target="_blank"
        href="http://join.instaciti.com/jff"
      >
        JOIN FOR FREE
      </a>
      <div
        class="collapse navbar-collapse desktopViewDisaplay"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item me-3 desktopViewDisaplay align-self-center">
            <a
              class="nav-link font16 font600 btn btn-sm custom-btnShadow text-white orangeGradientButton"
              href="http://join.instaciti.com/jff"
              target="_blank"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              data-bs-html="true"
              title='
                          <div>Sign Up now & get your free signature
                              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                          </div>
                      '
            >
              JOIN FOR FREE
            </a>
          </li>
          <li class="nav-item customColor align-self-center">
            <a class="nav-link font16" href="#">Support | Login</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <app-dealer-info></app-dealer-info>


  <portal-instaciti-footer></portal-instaciti-footer>
